module.exports = {
    landscape: process.env.SCREEN_MOBILE_LANDSCAPE || 992,
    portrait: process.env.SCREEN_MOBILE_PORTRAIT || 767,
};